/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { Screen, Title } from '../_shared/Screen';
import { PrimaryButton } from '../_shared/PrimaryButton';
import styles from './style.module.scss';

const BULLETS = ['jawline', 'leaner', 'hairline', 'younger', 'confident'];

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();

  useEffect(() => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'view', { page: 'hairstyle-value' });
  }, []);

  const next = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page: 'hairstyle-value' });
    onNext();
  };

  return (
    <Screen
      progress={20}
      hideBack={currentIndex === 0}
      onBack={onPrev}
      footer={<PrimaryButton onClick={next}>{t('hairstyleValue.cta')}</PrimaryButton>}
    >
      <div className={styles.chartTitle}>{t('hairstyleValue.chartTop')}</div>
      <div className={styles.chart} aria-hidden="true">
        <svg className={styles.chartSvg} viewBox="0 0 320 150" preserveAspectRatio="none">
          <defs>
            <linearGradient id="hsLineGrad" x1="0" y1="0" x2="1" y2="0">
              <stop offset="0" stopColor="#ff3d81" />
              <stop offset="1" stopColor="#9b2cff" />
            </linearGradient>
            <linearGradient id="hsFillGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stopColor="rgba(255,61,129,0.45)" />
              <stop offset="1" stopColor="rgba(155,44,255,0.02)" />
            </linearGradient>
          </defs>
          <path className={styles.chartArea} d="M8 132 C 96 124, 150 100, 312 20 L312 150 L8 150 Z" fill="url(#hsFillGrad)" />
          <path
            className={styles.chartLine}
            d="M8 132 C 96 124, 150 100, 312 20"
            fill="none"
            stroke="url(#hsLineGrad)"
            strokeWidth="3"
            strokeLinecap="round"
            pathLength={1}
            vectorEffect="non-scaling-stroke"
          />
        </svg>
        <span className={styles.chartBefore}>{t('hairstyleValue.before')}</span>
        <span className={styles.chartNow}>{t('hairstyleValue.now')}</span>
      </div>
      <Title>{t('hairstyleValue.title')}</Title>
      <ul className={styles.list}>
        {BULLETS.map((b) => (
          <li key={b} className={styles.item}>
            <span className={styles.check} aria-hidden="true">✓</span>
            {t(`hairstyleValue.bullets.${b}`)}
          </li>
        ))}
      </ul>
    </Screen>
  );
}

export default Page;
